const fr = {
  locales: ["fr"],
  messages: {
    "allRightsReserved": "tous droits réservés",
    "heading.events": "Evénements",
    "heading.rooms": "Salles de conférence",
    "heading.speakers": "Intervenants",
    "heading.presentations": "Présentation",
    "heading.accountInfo": "Information du compte",
    "heading.login": "SE CONNECTER",
    "heading.signup": "Inscription",
    "heading.persinalinfo": "Information personnelle",
    "heading.addEvent": "Créer un événement",
    "heading.transactions": "Transaction",
    "heading.transactions.intro": "Liste des transactions récentes",
    "heading.managing": "Gestion",
    "heading.eventVideos": "Vidéo de l'événement",
    "heading.allVideos": "Toutes les vidéo de",
    "button.login": "Se Connecter",
    "button.signup": "Inscription",
    "button.back": "Retour",
    "button.createEvent": "Créer un événement",
    "button.editEvent": "Modifier un événement",
    "button.uploadingLogo": "Modification du logo",
    "button.createRoom": "Créer",
    "button.editRoom": "Modifier une salle de conférence",
    "button.saveRoom": "Sauvegarder les modifications",
    "button.createSpeaker": "Créer",
    "button.create": "Créer",
    "button.editSpeaker": "Modifier un intervenant",
    "button.saveSpeaker": "Sauvegarder les modifications",
    "button.uploadingPhoto": "Modification de la photo",
    "button.createPresentation": "Créer une présentation",
    "button.editPresentation": "Modifier une présentation",
    "button.savePresentation": "Sauvegarder les modifications",
    "button.uploadingPresentation": "Envoi de ma présentation",
    "button.events.all": "liste des événements",
    "button.addPayment": "Tous les événements",
    "button.changePayment": "Ajouter un moyen de paiement",
    "error.input-username": "Invalide login",
    "link.view": "Visualisation",
    "link.home": "Accueil",
    "link.support": "Support",
    "link.dashboard": "Tableau de bord",
    "link.account": "Compte",
    "link.features": "Paramètres",
    "link.pricing": "Facturation",
    "link.about": "A propos",
    "link.login": "Connexion",
    "link.register": "Inscription",
    "link.logout": "Déconnexion",
    "link.download": "Télécharger",
    "link.room-software": "Logiciel d'enregistrement",
    "label.uploadLogo": "Chargement du logo",
    "label.logoUploaded": "Logo mis à jour",
    "label.actions": "Actions",
    "label.room.isLoggedIn": "Connecté?",
    "label.noPayment": "Aucun moyen de paiement enregistré",
    "label.noAddress": "Please update your account with a billing address",
    "select.displayMode.public": "Publique",
    "select.displayMode.password": "Mot de passe protégé",
    "select.displayMode.link": "Visualisation par lien",
    "select.theme.orange": "Orange",
    "select.theme.grey": "Gris",
    "select.theme.black": "Noire",
    "error.emailinvalid": "Cet e-mail est invalide",
    "error.alphanumeric": "Seuls les caractères alphanumériques sont acceptés",
    "error.atleast6": "Enter au moins 6 caractères alphanumériques",
    "error.passnomatch": "Les mots de passe saisis ne sont pas les mêmes",
    "action.heading": "Action confirmé!",
    "action.pre": "Etes-vous sûr de vouloir",
    "action.confirm": "Confirmer",
    "action.cancel": "Annuler",
    "action.delete-event": "Supprimer l'événement",
    "action.clone-event": "Dupliquer l'événement",
    "action.delete-room": "Supprimer la salle de conférence",
    "action.delete-speaker": "Supprimer l'intervenant",
    "input.email": "E-mail",
    "input.password": "Mot de passe",
    "input.password.confirm": "Confirmer le mot de passe",
    "input.title": "Titre",
    "input.name": "Nom",
    "input.firstname": "Prénom",
    "input.lastname": "Nom",
    "input.phone": "Téléphone",
    "input.mobile": "Mobile",
    "input.address": "Adresse",
    "input.zipcode": "Code postal",
    "input.city": "Ville",
    "input.country": "Pays",
    "input.agreeTerms": "Je suis d'accord avec les termes d'utilisation",
    "input.companyname": "Nom de la société",
    "input.event.name": "Nom de l'événement",
    "input.event.dates": "Dates",
    "input.event.start": "Date de début",
    "input.event.end": "Date de fin",
    "input.event.end.error.notBeforeStart": "La date doit être inférieur à la date de début de l'événement",
    "input.event.venue": "Nom du lieu de l'événement",
    "input.event.address": "Adresse de l'événement",
    "input.event.website": "Site web",
    "input.event.displayMode": "Mode d'affichage",
    "input.event.displayPassword": "Mot de passe du mode d'affichage",
    "input.event.logo": "Modification du logo",
    "input.event.uploadByDate": "Modification de la date",
    "input.event.uploadByDate.error.notAfterStart": "La date limite pour charger les fichiers ne peut pas être après la date de fin de l'événement",
    "input.event.web_ad": "Banière publicitaire",
    "input.event.theme": "Thème",
    "input.event.agreementMandatory": "Accord obligatoire de l'intervenant pour visualisation",
    "input.room.name": "Nom de la salle de conférence",
    "input.room.login": "login pour la salle de conférence",
    "input.room.password": "Mot de passe",
    "input.room.password.confirm": "Confirmer le mot de passe",
    "input.room.ad": "Banière publicitaire pour la salle de conférence",
    "input.speaker.name": "Nom de l'intervenant",
    "input.speaker.photo": "Photo de l'intervenant",
    "input.speaker.photoUpload": "Modification de la photo",
    "input.speaker.photoUploaded": "Photo modifiée",
    "input.speaker.description": "Description",
    "input.presentation.name": "Nom de la présentation",
    "input.presentation.date": "Date",
    "input.presentation.time": "Heure",
    "input.presentation.start.time": "Heure de début",
    "input.presentation.room": "Salle de conférence",
    "input.presentation.speaker": "Intervenant",
    "input.presentation.information": "Information",
    "input.presentation.presentationFile": "Fichier de la présenation",
    "input.presentation.presentationUpload": "Envoi de ma présentation",
    "input.presentation.presentationUploaded": "Présenation modifiée",
    "input.presentation.datetime": "Date et heure",
    "input.presentation.status": "Statut",
    "input.presentation.isPublic": "Public?",
    "button.presentation-download-latest": "Télécharger le dernier fichier pour la présentation",
    "alert.presentation-not-uploaded": "Aucun fichier pour la présentation n'a été chargé",
    "button.presentation-manage-files": "Gestion du fichier pour la présentation",
    "button.presentation-edit-info": "Editer la présentation",
    "button.presentation-delete": "Supprimer la présentation",
    "button.presentation-delete-file": "Supprimer le fichier de la présentation",
    "heading.files-uploaded-for": "fichier(s) chargé(s) pour",
    "label.file-uploaded-on": "Fichier chargé le",
    "link.profile-update": "Mise à jour du profil",
    "button.changePassword": "Changer le mot de passe",
    "link.contact": "Contact",
    "input.contact.name": "Nom",
    "input.contact.email": "E-mail",
    "input.contact.message": "Message",
    "button.presentations-all-download": "Télécharger tous les supports de présentations",
    "label.presentations-all-download": "Télécharger tous les fichiers de présentation d'un événement",
    "label.allow-popups-multiple-downloads": "Permet le téléchargement multiple",
    "input.event.set-password": "Entrer un mot de passe",
    "error.invalid-event-password": "Le mot de passe de l'événement est invalide",
    "error.enter-event-password": "Entrer le mot de passe de l'événement",
    "button.event-view": "Visualiser l'événement",
    "label.agreement-mandatory-message": "Affiché si l'option de l'accord de visualisation est cochée",
    "error.last-date-over": "Vous ne pouvez plus charger de fichiers de présentation",
    "label.no-presentations-for-upload": "Vous n'avez pas la possibilité de charger de fichier car vous n'êtes lié a aucune présentation pour cet événement",
    "button.send-email": "E-mail de l'intervenant",
    "error.file-upload": "Erreur lors du chargement du fichier",
    "contact.submit-success": "Le formulaire a été envoyé",
    "error.captcha-error": "La saisie ne correspond pas,veuillez recommercer",
    "error.mongo-error": "Erreur de connexion à la base de données,veuillez recommencer",
    "error.prompt-password": "Entrer le mot de passe",
    "error.invalid-password": "Mot de passe non valide",
    "event.fetch-success": "L'événement a été chargé avec succès",
    "error.date-over": "La date limite de chargement des fichiers de présentation est dépassée",
    "event.clone-success": "L'événement est dupliqué",
    "event.create-success": "L'événement est créé",
    "event.update-success": "L'événement a été mis à jour",
    "event.delete-success": "L'événement a été supprimé",
    "events.fetch-success": "L'événement a été chargé avec succès",
    "email.success": "E-mail envoyé",
    "error.[UPLOAD_URL]-missing": "[UPLOAD_URL] est obligatoire",
    "event.creating": "Création d'un événement",
    "presentation.create-success": "La présentation a été créée",
    "presentation.update-success": "La présentation a été mise à jour",
    "presentation.delete-success": "La présentation a été supprimée",
    "presentation.fetch-success": "La présentation a été chargée",
    "presentations.fetch-success": "La présentation a été chargée",
    "presentation.token-success": "La video de la présentation a été générée avec succès",
    "error.video-server": "Erreur du serveur de vidéo",
    "presentation.creating": "Création de la présentation",
    "room.create-success": "La salle de conférence a été créée",
    "room.update-success": "La salle de conférence a été mise à jour",
    "room.delete-success": "La salle de conférence a été supprimée",
    "room.fetch-success": "La salle de conférence a été chargée",
    "rooms.fetch-success": "La salle de conférence a été chargée",
    "error.duplicate-roomlogin": "Le login de la salle de conférence est déjà utilisé,veuillez saisir un autre login - ajoutez le nom de l'évènement par exemple",
    "room.login-success": "Connexion réussie",
    "room.logout-success": "Déconnexion réussie",
    "room.error-invalid-credentials": "Informations de connexion invalides",
    "error.invalid-room-token": "Jeton de la salle de conférence invalide",
    "success.authenticated": "Authentifié",
    "room.creating": "Création de la salle de conférence",
    "error.s3-error": "Erreur de connexion au serveur de fichiers",
    "error.presentation-not-found": "La présentation n'a pas été trouvée",
    "speaker.create-success": "L'intervenant a été créé",
    "speaker.update-success": "L'interveant a été mis à jour",
    "speaker.delete-success": "L'interveant a été supprimé",
    "speaker.fetch-success": "L'interveant a été chargé",
    "speakers.fetch-success": "L'interveant a été chargé",
    "speaker.creating": "Création de l'intervenant",
    "user.create-success": "Le profil a été créé",
    "user.update-success": "Le profil a été mis à jour",
    "user.fetch-success": "L'utilisateur a été chargé",
    "user.creating": "Création du compte",
    "user.updating": "Mise à jour du compte",
    "user.authenticating": "Authentification",
    "user.stripe-success": "Les informations concernant le paiement ont été enregistrées,vous pouvez naviguer sur le site",
    "error.server-error": "Erreur sur le serveur",
    "error.invalid-username": "Login invalid",
    "user.login-success": "connexion réussie",
    "error.invalid-token": "Session expirée",
    "error.duplicate-email": "L'e-mail que vous avez saisi est déjà utilisé, veuillez saisir un autre e-mail",
    "error.stripe-error": "Erreur de connxion au serveur de la banque",
    "success.subscription-updated": "Inscription mise à jour",
    "heading.send-email": "Envoyer un e-mail aux intervenants pour qu'ils puissent charger leur fichier de présentation",
    "form.speakers": "Intervenants",
    "form.cc": "CC",
    "form.bcc": "CCI",
    "form.email-subject": "Objet",
    "form.email-default-subject": "Charger la présentation pour",
    "heading.substitutions": "Modification dans le contenu de l'e-mail",
    "sub.speaker_name": "Nom de l'intervenant",
    "sub.upload_url": "Lien envoyer à l'intervenant pour le chargement des fichiers de présentation",
    "sub.video_upload_url": "URL for the speaker to upload the video.",
    "sub.due_date": "Fichier de présentation chargé avant échéance",
    "form.email-default-message": "[EVENT_LOGO]<br /><br />Cher [SPEAKER_NAME],<br /><br />Merci d'envoyer votre fichier de présentation via le lien suivant [UPLOAD_URL] avant le [UPLOAD_BY_DATE].<br /><br />Nous vous remercions également d'apporter une clé USB en sécurité.<br /><br />Bien cordialement,<br /><br />L'équipe d'organisation",
    "form.email-virtual-message": `[EVENT_LOGO]<br /><br />Cher [SPEAKER_NAME],<br /><br />Afin d’enregistrer votre présentation pour cet évènement, nous vous remercions de télécharger le logiciel e-slides en cliquant ici :  [SOFTWARE_LINK_FR]<br /><br />Une fois téléchargé et installé merci de choisir "accès intervenant"<br/>&nbsp;&nbsp;&nbsp;Identifiant de l'évènement : [EVENT_SLUG]<br />&nbsp;&nbsp;&nbsp;Mail de l'intervenant : [SPEAKER_LOGIN]<br/>&nbsp;&nbsp;&nbsp;Mot de passe de l'intervenant : [SPEAKER_PASSWORD]<br/><br/>Une fois connecté, vous devez choisir votre micro, l'écran à enregistrer (bien choisir l'écran ou sera affiché le diaporama du PPT en cas de bureau étendu) et votre webcam.<br/><br/>Ensuite vous enregistrer et choisissez la présentation à enregistrer. Vous enregistrez votre présentation avec le son comme si vous êtiez dans une salle de conférence.<br/><br/>A la fin de l'enregistrement vous pouvez enregistrer une autre présentation ou aller dans l'onglet transfert pour vérifier puis envoyer.<br/><br/>Bien cordialement,<br/><br/>L'équipe d'organisation`,
    "form.email-virtual-subject": 'Enregistrez votre présentation',
    "form.placeholder-default-message": "[UPLOAD_URL] n'est pas dans le texte",
    "form.send-email": "Envoyer",
    "heading.noEventVideos": "Aucune vidéo disponible pour le moment.",
    "user.logout-success": "Déconnexion réussie",
    "heading.upload-ppt": "Charger votre fichier pour la présentation",
    "heading.upload-video": "Charger votre video pour la présentation",
    "sub.event_logo": "Logo de l'événement",
    "input.room.login-short": 'login pour la salle',
    "filter.byRoom": "Filtrer par salle de conférence",
    "filter.byTitle": "Filtrer les présentations par titre",
    "filter.remove": "Supprimer le filtre",
    "heading.last-30-days-usage": "Usage for the last 30 days",
    /* TODO */
    "label.agree-broadcast": "Je donne mon accord pour que ma présentation soit diffusée après l'évènement",
    /* TODO */
    "button.saveEvent": "Sauvegarder les modifications",
    "action.delete-presentation-file": "delete the présentation file",
    /* TODO */
    "label.ppt": "PPT",
    /* TODO */
    "alert.not-recorded-yet": "Présentation has not been recorded yet",
    /* TODO */
    "ppt-status.no-ppt": "Pas de fichier de présentation",
    "ppt-status.ppt-uploaded": "Présentation chargée",
    "ppt-status.recording": "Enregistrement vidéo",
    "ppt-status.video-recorded": "Vidéo enregistrée",
    "ppt-status.published": "Publié",
    "form.email-save": "Sauvegarder l'e-mail",
    "form.email-load-saved": "Charger l'e-mail sauvegardé",
    "form.email-load-default": "Charger l'e-mail par défaut",
    "heading.form.basic_information": "Informations de base",
    "heading.form.venue_information": "Informations du lieu",
    "heading.form.room_information": "Gestion des salles de conference",
    "heading.form.website_information": "Informations sur les vidéos",
    "heading.form.engagement_information": "Participation Engagement Information",
    "input.event.forum": "Forum",
    "input.event.quiz": "Quiz",
    "input.event.moderator_site": "Modérateur",
    "input.event.moderator_site_password": "Mot de passe du modérateur",
    "input.event.audience_site": "Activer le site pour les participants de l'événement",
    "event.form.price-quiz": "2 crédits",
    "event.form.price-forum": "1 crédit",
    "event.form.price-moderator": "Gratuit",
    "label.status.uploadedPresentations": "Fichiers chargés",
    "label.status.recordedVideos": "Videos enregistrées",
    "label.status.uploadedVideos": "Videos chargées",
    "button.openModeratorSite": "Ouvrir le site modérateur",
    "button.openAudienceSite": "Ouvrir le site participants",
    "error.network-error": "Erreur réseau, merci de réessayer",
    "error.token-sent-wait-1-hour": "Veuillez attendre une heure pour réutiliser le service",
    "forgot-password.email-sent": "Merci de cliquer sur le lien reçu par email pour générer un nouveau mot de passe",
    "forgot-password.reset-success": "Le mot de passe a été régénéré, vous pouvez vous connecter.",
    "forgot-password.invalid-token": "Votre mot de passe est expiré, veuillez cliquer sur le lien pour réinitialiser votre mot de passe",
    "error.fileTooBig": "La taille du fichier est trop grande. Taille maximale de l'espace: 200 Ko.",
    "error.fileTooBig100": "La taille du fichier est trop grande. Taille maximale de l'espace: 100 Ko.",
    "heading.schedule-data": "Programme",
    "tab.schedule-colors": "Thèmes",
    "tab.schedule-types": "Types",
    "tab.schedule-associations": "Associations",
    "tab.schedule-sessions": "Sessions",
    "button.s.color-create": "Ajouter un thème",
    "button.s.type-create": "Ajouter un type",
    "button.s.association-create": "Ajouter une association",
    "button.s.session-create": "Ajouter une session",
    "button.s.color-update": "Modifier un thème",
    "button.s.type-update": "Modifier un type",
    "button.s.session-update": "Modifier un session",
    "button.s.association-update": "Modifier une association",
    "confirm.s.color-delete": "Etes-vous sur de vouloir supprimer ce thème?",
    "confirm.s.type-delete": "Etes-vous sur de vouloir supprimer ce type?",
    "confirm.s.association-delete": "Etes-vous sur de vouloir supprimer cette association?",
    "confirm.s.session-delete": "Etes-vous sur de vouloir supprimer ce session?",
    "alert.s.color.create_do": "Thème en création",
    "alert.s.type.create_do": "Type en création",
    "alert.s.association.create_do": "Association en création",
    "alert.s.session.create_do": "Creating Session",
    "color.create-success": "Thème créé",
    "type.create-success": "Type créé",
    "association.create-success": "Association créée",
    "session.create-success": "Session Created",
    "alert.s.color.update_do": "Mise à jour thème",
    "alert.s.type.update_do": "Mise à jour type",
    "alert.s.association.update_do": "Mise à jour aasociation",
    "alert.s.session.update_do": "Updating Session",
    "color.update-success": "Thème mis à jour",
    "type.update-success": "Type mis à jour",
    "association.update-success": "Association mise à jour",
    "session.update-success": "Session Updated",
    "color.delete-success": "Thème effacé",
    "type.delete-success": "Typeeffacé",
    "association.delete-success": "Association effacée",
    "session.delete-success": "Session Deleted",
    "edit": "Modifier",
    "delete": "Effacer",
    "button.uploadFile": "Envoyer fichier",
    "input.presentation.end_time": "Heure de fin",
    "input.end_time.error.notBeforeStartTime": "L'heure de fin doit être après l'heure de début",
    "input.presentation.color": "Thème",
    "input.presentation.type": "Type",
    "input.presentation.association": "Association",
    "input.presentation.session": "Session",
    "input.login": "identifiant",
    "input.event.slug": "URL du site",
    "error.slug-taken": "URL déjà utilisée",
    "form.toggle-speakers": "Toggle speakers",
    "heading.send-moderator-email": "Envoyer l'email modérateur",
    "form.select-speakers-without-ppt": "Intervenants sans PPT",
    "button.send-moderator-email": "Envoyer l'email aux modérateurs",
    "form.moderator-email-default-subject": "Invitation à modérer l'évènement",
    "form.moderator-site-missing": "URL modérateur absente",
    "form.moderator-password-missing": "Mot de passe modérateur absent",
    "form.moderator-email-default-message": "[EVENT_LOGO]<br /><br />Cher Modérateur,<br /><br />vous pouvez gérer l'évènement à l'adresse suivaqnte : [MODERATOR_SITE_URL] en utilisant le mot de passe suivant : [MODERATOR_SITE_PASSWORD].<br /><br />Merci.",
    "sub.moderator_site": "URL site modérateur",
    "sub.moderator_password": "Mot de passe site modérateur",
    "form.select-rooms": "Choisissez une salle pour cet évènement",
    "error.not-enough-credits": "Vous n'avez pas assez de crédits",
    "heading.purchase-credits": "Acheter des crédits",
    "alert.purchasing-credits": "Crédit en cours d'achats",
    "alert.purchased-credits": "Crédit acheté",
    "error.invalid-room": "Merci de choisir une salle appartenant à cet évènement",
    "error.invalid-date": "Merci de choisir une date comprise dans les dates de l'évènement",
    "heading.your-transactions": "Vos transactions (1 crédit gratuit à la création du compte)",
    "event.add-room-heading": "Ajouter une salle de conférence à votre événement",
    "heading.credits-available": "Crédits disponibles",
    "event.rooms-in-event": "Salles de conférence de votre événement",
    "event.rooms-not-in-event": "Salles de conférences",
    "event.adding-room": "Ajouter une salle de conférence à votre événement",
    "form.select-associations": "Associations autorisées à gérer leur présentations",
    "form.select.room": "Sélectionner une salle de conférence",
    "input.room.order": "Ordre des salles",
    "heading.credits-required": "[FR] Credits required",
    "heading.credits-to-be-purchased": "[FR] Credits to be purchased",
    "message.create-event-credits-to-be-purchased": "[FR] You will be prompted to purchase crédits when you click on 'Create Event'.",
    "message.create-event-credits-present": "[FR] You have enough crédits, click 'Create Event' to create the event.",
    "message.add-credit-card-prompt": "[FR] Please add a credit card to your account if you wish to purchase more crédits.",
    "input.event.audience_site_password": "[FR] Audience Site Password",
    "input.event.schedule_background_color": "Couleur de fond du programme",
    "input.event.schedule_text_color": "Couleur du texte du programme",
    "error.room-has-presentations": "[FR] Cannot delete room when it has présentations in this event.",
    "button.add-room-to-event": "[FR] Add Room To Event",
    "button.delete-room-from-event": "[FR] Remove Room From Event",
    "input.presentation.pdfConvert": "PDF Convert",
    "label.agree-pdfConvert": "Je suis d'accord pour que ma présentation soit diffusée en PDF",
    "input.presentation.publicVideo": "Vidéo Publique",
    "input.presentation.skip": "Passer les secondes",
    "label.pptSize": "Taille du fichier",
    "label.pptVersion": "Nb version chargée",
    "heading.manage-participants": "Manage Participants",
    "table.transactions.date": "Date",
    "table.transactions.type": "Type",
    "table.transactions.credits": "Crédits",
    "table.transactions.amount": "Amount",
    "table.transactions.invoice": "Invoice",
    "input.event.show_forum": "Show Forum",
    "input.event.show_quiz": "Show Quiz",
    "action.delete-presentation": "delete the présentation",
    "action.delete-video": "delete the video for",
    "input.emailContent": "Contenu du message :",
    "forgot.password": "Mot de passe oublié?",
    "have.account": "Déjà un compte?",
    "new.register": "Nouvelle Inscription",
    "user.welcome": "Bonjour",
    "user.creds": "crédit",
    "add.edit.event": "Créer / Modifier un évènement",
    "add.edit.room": "Créer / Modifier un Salle",
    "add.edit.speaker": "Créer / Modifier un Intervenant",
    "add.room": "Créer une salle",
    "add.visio": "Activate Visio",
    "text.event-slug": "Identifiant de l'événement",
    "create.event.form": "Créer un évènement",
    "event.form.name": "Nom de l’évènement",
    "input.description": "La description",
    "create.speaker.form": 'Créer un Intervenant',
    "nav.events": "Évènements",
    'nav.rooms': "Salles de conférence",
    "nav.speakers": "Intervenants",
    "nav.options": "plus d’options",
    "nav.themes": "Thèmes",
    "nav.types": "Types",
    "nav.associations": "Associations",
    "nav.credits": "Crédits",
    "nav.legal": "CGV",
    "edit-new": 'Ouvrir',
    "input.color.color": "Couleur",
    "button.save" : "Sauvegarder",
    "form.saved": "Forme enregistrés",
    "tooltip.event": "Gérer les événements",
    "tooltip.room": "Gérer les salles de conférence",
    "tooltip.speakers": "Gérer les intervenants",
    "tooltip.contact": "Contact & téléchargement",
    "advanced.settings": "Paramètres avancés",
    "label.uploadPhoto": "Envoyer la photo",
    "label.photoUploaded": "Photo téléchargée",
    "tooltip.download.latest":"Télécharger la dernière version du fichier de la présentation",
    "advanced.program": "Programme",
    "add.credits": "Ajoutez des crédits",
    "no.credits": "Nombre de crédits",
    "proceed.payment": "procéder au paiement",
    "is": "soit",
    "heading.simulator": "Simulateur",
    "no.rooms": "Nombre de salles",
    "no.days": "Nombre de jours",
    "additional.boradcast.years": "Années de diffusion supplémentaires",
    "enable.pdf.download": "Activer le téléchargement au format PDF",
    "disable.pdf.download": "Désactiver le téléchargement au format PDF",
    "show.video": "Afficher la vidéo",
    "hide.video": "Ne pas afficher la vidéo",
    "show.presentation": "Afficher la présentation",
    "hide.presentation": "Ne pas afficher la présentation",
    "yes": 'Oui',
    "no": 'Non',
    "email.heading.one": "Contactez les intervenants",
    "email.heading.two": "pour qu’ils puissent charger leurs fichiers de présentation",
    "email.speakers.select": "Selectionnez",
    "email.speakers.select2": "les destinataires",
    "form.select-speakers-without-video": "Intervenants sans vidéo",
    "load.email": "CHARGER UN e-mail",
    "view.history": "Voir l’historique",
    "common.sort": "trier",
    "from": "du",
    "to": "au",
    "accept.charge": "J’accepte d’être débité de",
    "input.room.streamingUrl": 'Streaming URL',
    "input.room.streamingPlaybackUrl": 'Streaming PlaybackUrl',
    "input.room.streamingWebcamUrl": 'Streaming Webcam URL',
    "input.room.streamingWebcamPlaybackUrl": 'Streaming Webcam PlaybackUrl',
    "input.room.streamingLogin": 'Streaming Login',
    "input.room.streamingPassword": 'Streaming Password',
    "done": "Valider",
    "change": "Changement",
    "accept.terms": "Vous devez accepter les termes d’utilisation pour pourvoir vous inscrire",
    "form.email.virtual": "Charger l'e-mail évènement virtuel",
    "error.event-has-presentations": "Avant d’effacer cet évènement, merci d’effacer toutes les présentations.",
    "error.chargeable-action": `Veuillez cochez la case  "J'accepte que je serai débité de 2 crédits`,
    "eslides.fields": "Champs réservés pour e-slides",
    "required.field": 'Ce champ est obligatoire',
    "input.audience.name": "Nom",
    "input.audience.email": "E-mail",
    "input.audience.moderator": "Modérateur",
    "input.audience.blocked": "Désactivé",
    "input.audience.unblocked": "Activé",
    "button.export-participants": "Export CSV",
    "button.invite-participant": "Invite",
    "button.download-import-template": "Download Template",
    "button.import-participants": "Import CSV",
    "button.submit": "Envoyer",
    "common.presentations.text": "Présentations",
    "common.videos.text": "Vidéos",
    "access.moderator.site": "pour l’accès au site modérateur",
    "download.app.text":  "N’oubliez pas de télécharger l’application",
    "site.moderator": "site modérateur",
    "site.audience": "Site événement",
    "deadline.text": "date limite après laquelle les intervenants ne peuvent plus uploader leur présentation",
    "rich.text": "TEXT ENRICHI",
    "purchase.text": "l' achat",
    "for.text": "pour",
    "link-credit-card": "Lier / mettre à jour la carte de crédit",
    "loaded.files": "des fichiers chargés",
    "recorded.videos": "des vidéos enregistrées",
    "loded.videos": "des vidéos chargées",
    "select": "Sélectionner",
    "show.sent.emails": "Suivi des envois d'e-mail",
    "email.sent": "E-mail envoyé",
    "add.logo": "Importer un logo",
    "email.fetch.wait": "Veuillez patienter...",
    "search.email": "Recherche par e-mail ou par nom",
    "no.sent.emails" : "Aucun e-mail n'a été envoyé pour cet événement",
    "message.please-wait": "Veuillez patienter...",
    "copied.text": "Copié!",
    "show.public.video.views": "Montrer le nombre total de vues sur les pages de videos publiques",
    "select.login.and.password": "Identifiant et mot de passe",
    "authenticationMode.global": "Création de compte",
    "authenticationMode.whitelist": "Liste d’utilisateurs",
    "total.presentations.created": "présentation(s) créés",
    "total.video.views": "Nombre total de vues",
    "views": 'vues',
    /* TODO */
    "action.delete-association": "delete the association",
    "action.delete-session": "delete the session",
    "action.delete-theme": "delete the theme",
    "action.delete-type": "delete the type",
    "drop-click-csv": "Déposez ici votre fichier CSV.",

    "error.items-to-be-created": "L'objet suivant doit être préalablement créé",

    "export.presentation-list": "Télécharger le programme",
    "import.presentation-list": "Charger le programme",
    "button.delete-presentations-without-ppt": "Supprimer toutes les présentations qui n'ont pas de support de présentation",

    "input.presentation.liveStreaming": "Live streaming",
    "username.header": "Username",
    "participants.list": "Charger les participants",
    "p.moderator": 'Modérateur',
    "p.user": 'Utilisateur',
    "unlocked": 'Unlocked',
    "locked": 'Locked',
    "button.upload-video": "Envoi de la video",
    "processing.csv": 'Chargement du fichier CSV en cours, veuillez patienter...',
    "event.updating": "Mise à jour de l'événement",
    "presentation.updating": "Mise à jour de la présentation",
    "room.updating": 'Mise à jour de la salle',
    "speaker.updating": "Mise à jour de la Intervenant",
    "input.externalPdfLink": "Or external PDF Link",
    "block.access.presentation.with.password": "Bloquer l'accès aux présentations par un mot de passe",
    "allow.creating.account": "Autoriser l'accès par création de compte",
    "allow.validate.accounts": "Valider automatiquement les comptes créés",
    "allow.anonymous.access": "Autoriser l'accès aux présentations aux utilisateurs sans compte",
    "header.source": "Source",
    "header.photo": "Photo",
    "header.login": "Identifiant",
    "edit.participant": "Edit Participant List",
    "add.participant": "Ajouter un participant",
    "input.photo": "Photo",
    "input.state.locked": "Locked?",
    "input.audience.disabled": "Disabled",
    "error.login-taken": "This login is already taken",
    "error.email-taken": "This email is already in use",
    "message.user-created": "User has been created",
    "message.user-updated": "User has been updated",
    "message.checking.login-and-email": "Checking Login and Email",
    "message.creating.user": "Creating User",
    "message.updating.user": "Updating User",
    "user-list-add.success": "User added Successfully",
    "user-list-email.in.use": "This email address is already in use.",
    "email.participants": 'Email Participants',
    "email.error": 'Error Sending Email',
    "delete.participants": 'Delete Selected Participants?',
    "input.password-new": "Enter new password (optional)",
    "input.to": 'To',
    "input.subject": 'Objet',
    "button.add": 'Ajouter',
    "tooltip.delete-attendees": 'Supprimer les participants sélectionnés',
    "tooltip.email-attendees": 'Envoyer un e-mail aux participants sélectionnés',
    "authorize.assosication.login": "Autoriser les associations à gérer et modérer leurs presentations",
    "authorize.speaker.login": "Autoriser les intervenants à modérer leurs présentations",
    "connection.externalURL": "Connexion à un site externe",
    "table.header.state": "Etat",

    "state.activated":"Activé",
    "state.desactivated":"Désactivé",
    "moderator.activated":"Modérateur",
    "moderator.desactivated":"Participant",
    "speaker.activated":"Intervenant",
    "speaker.desactivated":"Non intervenant",
    "association.activated":"Association",
    "association.desactivated":"Pas une association",
  }
}

export default fr;
